// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Landing from "../../templates/Landing.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

let heroImg = {
  src: "https://images.instapainting.com/6126fe5c829ce18a208b4577.jpg",
  alt: "Watercolor portrait painting of a cat in the style of Udnie, Young American Girl by Francis Picabia"
};

let pageTitle = "Custom Cat Portrait Painting";

let title = "Order a personalized";

let title2 = " oil painting of your cat";

let metaDescription = "Turn your cat photo into a personalized, handmade portrait. View thousands of examples from real customers. Ready to be shipped in about 7-10 days.";

let description = `Turn your favorite photo into a 100% handmade physical painting from a master artist in oil, watercolor, charcoal, or other mediums. Select a product, upload a photo, and we'll find the best artist to paint cat paintings and ship it to your door. Upload your cat's precious photo to get started today!`;

let secondaryContent = {
  title1: "Custom Cat",
  title2: "Portrait Painting",
  body: `You can browse cat painting samples from real customers and artists. Our professional artists offer a variety of cat painting styles to adequately capture the essence of your feline friend and create the perfect addition to your household decor. Whether a cat renaissance painting, a weird cat painting, a Victorian cat painting or something else is your style, we can help you achieve it. All of our experienced artists use the highest quality materials to provide exceptional work that withstands the test of time. Not to mention, you’ll have the opportunity to communicate directly with the artist of your choice to make sure you receive a finished product that's exactly what you want and need.`
};

let mainCta = {
  text: "Upload a Photo",
  link: "/assets"
};

let altCta = {
  text: "Browse Cats Gallery",
  link: "/gallery/cat"
};

let products = [
  {
    title: "Oil Painting",
    src: "https://images.instapainting.com/616188cb562b163a058b456b.jpg?fp-z=1.25&fp-x=0.4&fp-y=0.5",
    imageAlt: "Oil portrait of two cats in the style of Composition by Piet Mondrian",
    sku: "custphotoreal",
    price: 89
  },
  {
    title: "Watercolor",
    src: "https://images.instapainting.com/5d75fc6387456f31768b456d_w0.jpg?fp-z=1.2&fp-y=0.55",
    imageAlt: "Watercolor portrait painting of a cat",
    sku: "custwatercolor",
    price: 89
  },
  {
    title: "Charcoal",
    src: "https://images.instapainting.com/613a1bd82fcd0f1e088b4567_w0.jpg?fp-z=1.25&fp-y=0.4&fp-x=0.5",
    imageAlt: "Charcoal drawing of a cat with a young child",
    sku: "custcharcoal",
    price: 89
  },
  {
    title: "Pencil Drawing",
    src: "https://images.instapainting.com/596f608c87456fd0088b456a.jpg?fp-z=2.0&fp-y=0.6",
    imageAlt: "Pencil drawing of two jet black cats",
    sku: "custpencil",
    price: 89
  },
  {
    title: "Colored-Pencil",
    src: "https://images.instapainting.com/5f4af52887456f9a228b4571.jpg?fp-z=1.0",
    imageAlt: "Colored pencil drawing of two cats in the style of Nude Descending a Staircase by Marcel Duchamp",
    sku: "custpencil",
    price: 89
  }
];

let reviews = [
  {
    name: "Alec Gougebas",
    location: "Minnetonka, US",
    review: `Fantastic artistic skills and very willing to adjust the painting to fit even the smallest requests. Always respond by the deadline and they did their best to make sure i was a satisfied with my painting. I will recommend this service to friends and family due to the excellent job they did.`,
    link: "/products/gallery/custmixedmedia/58fa92ae87456f5a0a8b4581?order=1",
    image: "https://images.instapainting.com/59117acf87456faa1a8b456f_w0.jpg?fit=crop&crop=focalpoint&fp-y=.55&fp-z=2",
    imageAlt: "",
    date: new Date("5/09/2017")
  },
  {
    name: "Holly Spence",
    location: "Menlo Park, US",
    review: `Painting was quick and artist was happy to do a small change on it after the first image was sent over. Had some trouble with delivery but it was not the artists fault, and we happily finally located the painting. It looks even better in person than in the image! My husband was really surprised and happy with a very unique gift. Thanks for your hard work on this!`,
    link: "/products/gallery/custphotoreal/5900e91087456f24348b459d/?order=1",
    image: "https://images.instapainting.com/590917ba87456f236f8b457b.jpg",
    imageAlt: "Oil portrait of a man with his cat",
    date: new Date("05/22/2017")
  },
  {
    name: "Michael McDonald",
    location: "Alexandria",
    review: `This looks fantastic`,
    link: "/products/gallery/custmixedmedia/581f660987456f4f748b45b9/?order=1",
    image: "https://images.instapainting.com/5826d85e87456f644c8b4567.jpg",
    imageAlt: "",
    date: new Date("11/16/2016")
  }
];

let contentBlocks = [
  {
    title1: "Hand-Painted Portrait of",
    title2: "Your Feline",
    body: `If you’d like to commission an artist to create a one-of-a-kind cat portrait painting, you’ve come to the right place. What better way to honor and cherish the life of a cat that has passed away, tell a story about a favorite memory, or capture your cat’s personality than with a hand-painted cat portrait! With a custom piece of art, you can do all these things and more.

Whether you want to hang the artwork in your own home, donate it to a local business, or give a friend a priceless gift, we can help by matching you with an artist that suits your style and exact specifications. Our artists can create a variety of products including a watercolor cat painting, cat acrylic painting, realistic cat portrait, and more. Depending on your preferences and budget, we can help you get the style you’re after.`
  },
  {
    title1: "Capture Your Cute Kitten",
    title2: "on Canvas",
    body: `Unfortunately, the adorable kitten phase only lasts so long. Before you know it, your fuzzy, tiny kitty is a full-grown adult cat. But what if there was a creative way to hold on to those memories for just a little bit longer? Wouldn’t it be nice to have a fun reminder of those sweet times that you can frequently revisit in your home? Well, a personalized kitten painting can do just that!

With a cute kitten painting, our talented artists can help you capture all that adorable, fuzzy cuteness and package it into a quality, handmade work of art. All of our kitten portraits are real, handcrafted artworks created by experienced and passionate artists. So when you commission one of our artists to paint your kitten, you expect the best quality materials, easy and timely communication throughout the production process, and fast, convenient shipping when the work is done.`
  },
  {
    title1: "Turn a Funny Photo into a",
    title2: "Cherished Memory",
    body: `Sometimes, you just need a good laugh. And thankfully, cats are great for that! If you have a specific photo of your cat that consistently brings you joy, makes you laugh, and cheers you up on bad days, it’s likely a great candidate for a one-of-a-kind funny cat painting created by a real artist.

A custom funny cat painting is an excellent way to memorialize a feline friend that has recently passed away. It also makes for a unique and memorable gift for a friend or loved one. Or, you can use a custom cat painting to add a bit of personality and flair to your home. (Talk about a conversation starter!)

A funny cat painting can be a great gift or a creative way to decorate your home. But, more often than not, these works of art end up being meaningful and powerful expressions of love. The type of love you can only have for your precious cat, friend, and loyal companion.`
  },
  {
    title1: "",
    title2: "Start by Uploading Your Photo Today",
    body: `If you’re searching for a talented artist to recreate the essence of your feline pal, Instapainting can help! We’ll guide you through the process of hiring an experienced professional artist to create a custom cat portrait that matches your specifications. When you hire one of our artists, you never have to worry about receiving poor-quality work or struggling through a difficult production process. Instead, our clients rave about how easy the process is, the great experiences they have while working with our talented artists, and the beautiful end results they receive.

If you’d like to have an artist create a distinctive custom cat portrait in less than three weeks’ time, you can start by uploading your cat’s photo today. Just select the artwork product type of your choice, upload a picture of your sweet feline, add your instructions for the artist, and submit your order. From there, we’ll match you with interested artists who can provide the type of portrait that aligns with your stylistic preferences. During the process, you even get unlimited revisions, so you can have peace of mind knowing the finished cat painting you receive will be everything you wanted. Upload your cat’s photo to get started with Instapainting!`
  }
];

function CatPaintingsPage(props) {
  return JsxRuntime.jsx(Landing.LandingPage.make, {
    pageTitle: pageTitle,
    heroImg: heroImg,
    title: title,
    title2: title2,
    description: description,
    metaDescription: metaDescription,
    secondaryContent: secondaryContent,
    mainCta: mainCta,
    altCta: altCta,
    products: products,
    reviews: reviews,
    contentBlocks: contentBlocks
  });
}

let make = CatPaintingsPage;

let $$default = CatPaintingsPage;

export {
  heroImg,
  pageTitle,
  title,
  title2,
  metaDescription,
  description,
  secondaryContent,
  mainCta,
  altCta,
  products,
  reviews,
  contentBlocks,
  make,
  $$default as default,
}
/*  Not a pure module */
